import customPlan from "../../../../../lib/common/js/components/customPlan"

const ANIMATION_DURATION = 10000
const ITEM_COUNT = 3

export default (getView) =>
  ({ nextStepPath, timeout } = {}) => ({
    ...customPlan(getView)({ nextStepPath, timeout }),

    revealedCount: 0,
    isComplete: false,

    init() {
      this.handleLoadingEnd = this.handleLoadingEnd.bind(this)
      this.commonInit()
      this._startRevealSequence()
    },

    _startRevealSequence() {
      const step = ANIMATION_DURATION / ITEM_COUNT
      for (let i = 1; i < ITEM_COUNT; i++) {
        setTimeout(() => {
          if (!this.isComplete) {
            this.revealedCount = i
          }
        }, step * i)
      }
    },

    handleLoadingEnd() {
      this.revealedCount = ITEM_COUNT
      this.isComplete = true
      setTimeout(() => {
        window.location = nextStepPath || this.pageState?.nextStepPath
      }, timeout || 2000)
    },
  })